import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Table
} from "reactstrap";
import axios from "axios";
import { permissionStructure } from "./permissionStructure";

import { hasPermission } from "../../../helpers/permission";
import toast from "react-hot-toast";
const Role = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;

  const [modal, setModal] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [currentRoleId, setCurrentRoleId] = useState(null);

  const toggleModal = () => setModal(!modal);

  // 🔥 Fetch Roles
  const fetchRoles = async () => {
    const res = await axios.get(`${baseurl}/admin/roles`);
    setRoles(res.data);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const togglePermission = (key) => {
    setSelectedPermissions((prev) =>
      prev.includes(key)
        ? prev.filter((p) => p !== key)
        : [...prev, key]
    );
  };

  // 🔥 Save / Update Role
  const handleSaveRole = async () => {
    if (!roleName) return alert("Role name required");

    if (isEdit) {
      await axios.put(`${baseurl}/admin/roles/${currentRoleId}`, {
        roleName,
        permissions: selectedPermissions
      });
      toast.success('Role updated successfully!', 'success');
    } else {
      await axios.post(`${baseurl}/admin/roles`, {
        roleName,
        permissions: selectedPermissions
      });
      toast.success('Role updated successfully!', 'success');
    }

    resetForm();
    toggleModal();
    fetchRoles();
  };

  // 🔥 Edit Role
  const handleEdit = async (role) => {
    const res = await axios.get(
      `${baseurl}/admin/roles/${role.id}`
    );

    setRoleName(role.role_name);
    setSelectedPermissions(res.data.permissions);
    setCurrentRoleId(role.id);
    setIsEdit(true);
    toggleModal();
  };

  const resetForm = () => {
    setRoleName("");
    setSelectedPermissions([]);
    setIsEdit(false);
    setCurrentRoleId(null);
  };

  return (
    <div className="page-content">
      <Container fluid>

        {/* Role List */}
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between mb-3">
                  <h4>Roles</h4>
                  <Button color="primary" onClick={() => {
                    resetForm();
                    toggleModal();
                  }}>
                    Add Role
                  </Button>
                </div>

                <Table bordered>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Role Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role) => (
                      <tr key={role.id}>
                        <td>{role.id}</td>
                        <td>{role.role_name}</td>
                        <td>
                          <Button
                            size="sm"
                            color="warning"
                            onClick={() => handleEdit(role)}
                          >
                            Edit
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Role Modal */}
        <Modal isOpen={modal} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            {isEdit ? "Edit Role" : "Add Role"}
          </ModalHeader>

          <ModalBody>
            <div className="mb-3">
              <Label>Role Name</Label>
              <Input
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                placeholder="Enter Role Name"
                readOnly={isEdit}
              />
            </div>

            <Table bordered responsive>
  <thead>
    <tr>
      <th>Module / Resource</th>
      <th className="text-center">View</th>
      <th className="text-center">Add</th>
      <th className="text-center">Edit</th>
      <th className="text-center">Delete</th>
    </tr>
  </thead>
  <tbody>
  {Object.entries(permissionStructure).map(([moduleKey, module]) => (
    <React.Fragment key={moduleKey}>
      
      {/* Module Header Row */}
      <tr style={{ backgroundColor: "#f8f9fa" }}>
        <td colSpan="5">
          <strong>{module.label}</strong>
        </td>
      </tr>

      {/* Sub Resources */}
      {Object.entries(module.resources).map(([resource, actions]) => {
        const baseKey = `${moduleKey}.${resource}`;

        return (
          <tr key={baseKey}>
            <td style={{ paddingLeft: "30px" }}>
              {resource.replace(/_/g, " ").toUpperCase()}
            </td>

            {["view", "create", "edit", "delete"].map((action) => {
              const permissionKey = `${baseKey}.${action}`;
              const isAvailable = actions.includes(action);

              return (
                <td key={action} className="text-center">
                  {isAvailable ? (
                    <Input
                      type="checkbox"
                      checked={selectedPermissions.includes(permissionKey)}
                      onChange={() =>
                        togglePermission(permissionKey)
                      }
                    />
                  ) : (
                    "-"
                  )}
                </td>
              );
            })}
          </tr>
        );
      })}
    </React.Fragment>
  ))}
</tbody>
</Table>

            <div className="text-end">
              <Button color="success" onClick={handleSaveRole}>
                {isEdit ? "Update Role" : "Save Role"}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};

export default Role;